import { useCallback, useEffect } from "react";
import {
  getAccountDetails,
  setAccountDetails,
} from "../../redux/reducers/accountSlice";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import { getAccountIdentity } from "../../services/apiService";

function UserSetting() {
  const userDetails = useAppSelector(getAccountDetails);
  const dispatch = useAppDispatch();

  const fetchAccountIdentity = useCallback(async () => {
    try {
      const userIdentity = await getAccountIdentity();
      dispatch(setAccountDetails(userIdentity.data));
    } catch (error) {
      console.error("Error fetching account identity:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!userDetails?.display_name) {
      fetchAccountIdentity();
    }
  }, [userDetails, fetchAccountIdentity]);

  return (
    <fieldset className="mg-b15">
      <legend>User Settings</legend>
      <div className="d-flex available-field">
        <span>Name</span>
        <p className="form-control">{userDetails?.display_name}</p>
      </div>
      <div className="d-flex available-field">
        <span>Username</span>
        <p className="form-control">{userDetails?.username}</p>
      </div>
    </fieldset>
  );
}

export default UserSetting;
